module.exports = __webpack_public_path__ + "static/themework-logo-c9eaf0e2360522c0ed0bb5acfac147fe.svg";